import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Header({ calcObj }: any) {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('dpu_calculator');
    const [top, setTop] = useState(0);
    const { check1, step } = calcObj;

    const steps = [check1 === 2 ? t('header_step1_b') : t('header_step1'), check1 === 1 ? t('header_step2') : t('header_step2_b'), t('header_step3')];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let h = 0;
            const bar = document.querySelector('.announcement-bar') as HTMLElement;
            if (bar) {
                const styles = window.getComputedStyle(bar);
                const position = styles.position;
                if (position === 'sticky') {
                    h += bar?.offsetHeight;
                }
            }
            const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
            if (header) {
                const styles = window.getComputedStyle(header);
                const position = styles.position;
                if (position === 'sticky') {
                    h += header?.offsetHeight;
                }
            }
            setTop(h);
        }
    }, []);

    return (
        <div className={`dpu-calculator-header ${css['dpu-calculator-header']}`} style={{ top: `${top}px` }}>
            <div className="header-inner">
                <div className={`bg-lines ${step === 3 ? 'full' : ''}`}>
                    <div className={`line line1 ${step === 1 && check1 ? 'half' : step === 1 && !check1 ? 'init' : ''}`}></div>
                    <div className={`line line2 ${step === 3 ? 'full' : ''}`}></div>
                </div>
                <ul className="steps">
                    {steps?.map((item: string, k: number) => (
                        <li className={`step step${k + 1} ${step > k ? 'blue' : ''}`} key={k}>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="box-h5">
                <div className={`lines ${step >= 3 ? 'full' : ''}`}>
                    <div className={`line line1 ${step === 1 && check1 ? 'half' : step === 1 && !check1 ? 'init' : 'full'}`}></div>
                    <div className={`line line2 ${step >= 2 ? 'full' : ''}`}></div>
                    <div className={`line line3 ${step >= 3 ? 'full' : ''}`}></div>
                </div>
                <p className="step-text">{steps[step - 1]}</p>
            </div>
        </div>
    );
}
